import { ArrowRight, CheckCircle2, DollarSign } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SeamlessMigrationToDynamics365BusinessCentral() {
  return <section className="relative min-h-screen flex items-center justify-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409748/img/hero_migration_background.png)]">
        <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm"></div>
      </div>

      {}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20 text-center">
        <div className="animate-fade-in-up">
          <h1 className="font-display font-bold text-[2.25rem] md:text-[3rem] lg:text-[3.5rem] leading-snug tracking-tight text-white mb-6">
            Seamless Migration to<br />Dynamics 365 Business Central
          </h1>
          
          <p className="text-lg md:text-xl leading-relaxed text-white/90 mb-8 max-w-3xl mx-auto">
            Fast, reliable ERP migration across North America. Migrate from Microsoft Dynamics GP to Dynamics 365 Business Central with precision, speed, and audit-ready results.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 animate-fade-in-up-delay-100">
            <Link to="/ContactPage">
              <Button size="lg" className="bg-accent text-white font-semibold hover:bg-accent-hover shadow-medium h-12 px-8 rounded-md transition-all duration-[120ms] hover:-translate-y-0.5 hover:shadow-strong">
                Get Started Today
                <ArrowRight className="size-5" />
              </Button>
            </Link>
            
            <Link to="/PricingPage" className="inline-flex items-center gap-2 text-white font-semibold hover:text-white/80 transition-colors duration-[120ms]">
              View Pricing Packages
              <ArrowRight className="size-5" />
            </Link>
          </div>

          {}
          <div className="mb-12 animate-fade-in-up-delay-100">
            <div className="inline-flex items-center gap-3 bg-accent/90 backdrop-blur-md border-2 border-accent-light px-6 py-4 rounded-md shadow-strong">
              <DollarSign className="size-8 text-white shrink-0" />
              <div className="text-left">
                <p className="font-display font-bold text-white text-lg leading-tight">
                  US-Based Businesses Save Big!
                </p>
                <p className="text-white/95 text-sm font-medium">
                  Take advantage of CAD pricing for significant savings
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto animate-fade-in-up-delay-200">
            <div className="flex items-start gap-3 text-left bg-white/10 backdrop-blur-md border border-white/20 rounded-md shadow-soft p-6">
              <CheckCircle2 className="size-6 text-accent shrink-0 mt-0.5" />
              <div>
                <h3 className="font-display font-semibold text-white text-lg mb-1">Proven Migration Frameworks</h3>
                <p className="text-white/80 text-sm leading-relaxed">Repeatable processes tailored for mid-sized North American businesses</p>
              </div>
            </div>

            <div className="flex items-start gap-3 text-left bg-white/10 backdrop-blur-md border border-white/20 rounded-md shadow-soft p-6">
              <CheckCircle2 className="size-6 text-accent shrink-0 mt-0.5" />
              <div>
                <h3 className="font-display font-semibold text-white text-lg mb-1">Audit-Ready Reporting</h3>
                <p className="text-white/80 text-sm leading-relaxed">Clean cheque remittance templates, mapped data, and branded outputs</p>
              </div>
            </div>

            <div className="flex items-start gap-3 text-left bg-white/10 backdrop-blur-md border border-white/20 rounded-md shadow-soft p-6">
              <CheckCircle2 className="size-6 text-accent shrink-0 mt-0.5" />
              <div>
                <h3 className="font-display font-semibold text-white text-lg mb-1">Scalable Pricing</h3>
                <p className="text-white/80 text-sm leading-relaxed">Multiple packages starting at $7,500 CAD based on migration complexity</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}